import { put, takeLatest } from "redux-saga/effects";
import { getCycle, getFilterReferences } from "src/redux/actions";
import { IGetParticipantsResourcesAction } from "../../types";
import { SagaIterator } from "@redux-saga/core";
import { IExtendedCycle } from "src/common/types";

type GetParticipantsResources = SagaIterator | Promise<IExtendedCycle>;
function* getParticipantsResources({ payload: cycleId }: IGetParticipantsResourcesAction): GetParticipantsResources {
  try {
    const cycle = yield getCycle(cycleId);
    const filterReferences = yield getFilterReferences();

    yield put({
      payload: {
        cycle,
        filterReferences
      },
      type: "GET_PARTICIPANTS_RESOURCES_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e);
    yield put({
      type: "GET_PARTICIPANTS_RESOURCES_REJECTED"
    });
  }
}

export default function* cycleParticipantsWatcher() {
  yield takeLatest("GET_PARTICIPANTS_RESOURCES", getParticipantsResources);
}
